import { Link } from 'react-router-dom';
import { articles } from '@/mocks/homeData';

export default function ArticlePreview() {
  return (
    <section className="relative py-14 md:py-20 px-4 md:px-6 bg-foreground-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full border border-background-50/20 text-xs font-semibold text-background-50/70 bg-background-50/5 mb-3 whitespace-nowrap">
              Latest Guides
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              Buying Guides &amp; Reviews
            </h2>
            <p className="mt-2 text-sm text-background-50/50 max-w-xl">
              Expert guides, product comparisons, and shopping tips from the AllChinaBuy Spreadsheet research team.
            </p>
          </div>
        </div>

        {/* Scrollable Row */}
        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:-mx-6 md:px-6 scroll-smooth">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/guide/${article.slug}`}
              className="flex-shrink-0 w-[260px] md:w-[300px] group cursor-pointer"
            >
              <div className="aspect-[4/3] rounded-xl overflow-hidden bg-background-200 mb-4">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <span className="inline-block px-2 py-0.5 rounded-full bg-background-50/10 text-[10px] font-medium text-accent-400 mb-2 whitespace-nowrap">
                {article.category}
              </span>
              <h3 className="text-sm md:text-base font-semibold text-background-50 group-hover:text-accent-300 transition-colors leading-snug line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-xs text-background-50/40 leading-relaxed line-clamp-2 mb-2">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 text-xs text-background-50/50">
                <span>{article.date}</span>
                <span className="w-1 h-1 rounded-full bg-background-50/30"></span>
                <span>{article.readTime}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}